var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgInputFieldError = function SvgInputFieldError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.001 14.721c.582 0 1.053-.48 1.053-1.071 0-.592-.471-1.072-1.053-1.072-.58 0-1.052.48-1.052 1.072 0 .591.471 1.071 1.052 1.071ZM9.896 5.295a1.196 1.196 0 0 0-1.073 1.307l.4 4.393a.814.814 0 0 0 .715.728.79.79 0 0 0 .863-.728l.4-4.393v-.214c-.084-.665-.652-1.158-1.305-1.093Z",
    fill: "#FF0404"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.579 13.5 12.506 1.457A2.862 2.862 0 0 0 10.001 0a2.862 2.862 0 0 0-2.504 1.457L.424 13.5c-.547.943-.568 2.057-.042 3A2.876 2.876 0 0 0 2.929 18h14.124c1.073 0 2.02-.557 2.547-1.5a2.946 2.946 0 0 0-.021-3Zm-1.453 2.143c-.21.386-.61.621-1.052.621H2.929c-.442 0-.842-.235-1.053-.621-.21-.386-.21-.857.021-1.243L8.95 2.336c.231-.386.61-.6 1.052-.6.442 0 .821.214 1.053.6l7.072 12.043c.211.407.211.857 0 1.264Z",
    fill: "#FF0404"
  })));
};

export default SvgInputFieldError;